const getApiUrl = () => {
  // Get the current domain from window.location
  const currentDomain =
    typeof window !== "undefined" ? window.location.origin : "";

  // Direct checks for specific domains
  if (
    currentDomain.includes("localhost") ||
    currentDomain.includes("127.0.0.1")
  ) {
    return "http://localhost:3002";
  }

  if (currentDomain === "https://mineksamen.dk") {
    return "https://api-key-server-sigma.vercel.app";
  }

  // Default fallback for other domains
  return "https://api-key-server-sigma.vercel.app";
};

export const apiUrl = getApiUrl();
